<script setup>
import { ref, computed } from "vue";
import { useStore } from "vuex";

const store = useStore();


</script>

<template>
    <div class = "loading-spinner">
        <img src = "../../public/assets/imgs/loading-bar-back.png" class = "background">
        <img src="../../public/assets/imgs/loading-bar-spin.png" class="spinner">
    </div>
</template>

<style lang="scss" scoped>
@import '../sass/GlobalClasses';
@import '../sass/Settings';

.loading-spinner {
    position: relative;
    width: vw(108);
    height: vw(108);
    box-sizing: border-box;

    .background{
        @extend %absolute-fill;
        width: vw(108);
        height: vw(108);
    }

    .spinner {
        @extend %absolute-fill;
        width: vw(108);
        height: vw(108);
        animation: spin 1s linear infinite;
    }
}
</style>
